import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { FILE_LIST_CONFIG, fileListButton, fileListInfoAlertConfig, selectedFileListButton, selectedFileListInfoAlertConfig } from './utils/file-list.configs';
import { Store } from '@ngrx/store';
import { GetFileExplorerFileList, OrderFileExplorerReset, IngestMultipleFilesExplorer, ResetDrive } from '../../state/file-explorer.actions';
import { RappiderFileExplorerWithSelectedListModule } from 'libs/components/src/lib/components/file-explorer-with-selected-list/file-explorer-with-selected-list.module';
import { FullPaths } from 'libs/shared/src/lib/definitions/page-definition';
import { Router } from '@angular/router';
import { FILE_LIST_EDIT_FORM_CONFIG } from './utils/file-list-edit-form-config';
import { getProjectModelsWithFields } from '@rappider/shared';
import { getCategories } from 'libs/shared/src/lib/states/category/utils/get-categories-selector'
import { Category } from '@rappider/rappider-sdk';

@Component({
  selector: 'rappider-file-explorer-list',
  standalone: true,
  imports: [
    CommonModule,
    RappiderFileExplorerWithSelectedListModule
  ],
  templateUrl: './file-list.component.html',
  styleUrls: ['./file-list.component.scss'],
})
export class RappiderFileExplorerFileListComponent implements OnInit, AfterViewInit, OnDestroy {

  subscriptions: Subscription[] = [];
  activeEntityData = [];
  listGridConfig = FILE_LIST_CONFIG;
  selectedItem: any;
  loading = false;
  submitButtonLoading = false;
  fileListButton = fileListButton;
  selectedFileListButton = selectedFileListButton;
  fileListInfoAlertConfig = fileListInfoAlertConfig;
  selectedFileListInfoAlertConfig = selectedFileListInfoAlertConfig;
  // It stores the state of the nested folders.
  folderOrder;
  selectedList = [];
  isFileListStatic = false;
  fileListEditFormConfig = FILE_LIST_EDIT_FORM_CONFIG;
  selectedListEditFormVisible = true;
  isApproved = true;
  activeIngestDataStatus = 'IngestToTheDefaultDataTableOfTheDataSource';
  fileMetadata = { key: 'createNewProjectModel', value: false };
  selectProjectModels;
  categories: Category[] = [];
  categoryId: string = '';

  constructor(
    private store: Store<any>,
    private router: Router
  ) { }

  ngOnInit() {
    this.store.dispatch(GetFileExplorerFileList({ payload: { searchText: '' } }));
    this.subscriptions = [
      this.subscribeToFileExplorerFiles(),
      this.subscribeToFileExplorerLoading(),
      this.subscribeToFileExplorerFolderOrder(),
      this.subscribeToFileExplorerSubmitButtonLoading(),
      this.subscribeToActiveProvider(),
      this.subscribeToProjectModels(),
      this.subscribeToCategories()
    ];
  }

  @ViewChild('fileListExplorer') fileListExplorer!: ElementRef;
  private resizeObserver!: ResizeObserver;
  gridHeight: number = 0;

  ngAfterViewInit() {
    this.resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        this.gridHeight = entry.contentRect.height;
        // To find the total height of the td elements, the other elements are removed
        this.listGridConfig.pageSize = Math.floor((entry.contentRect.height - (this.folderOrder?.length ? 350 : 330)) / 36);
        this.listGridConfig = { ...this.listGridConfig };
      }
    });

    if (this.fileListExplorer?.nativeElement) {
      this.resizeObserver.observe(this.fileListExplorer.nativeElement);
    }
  }

  ngOnDestroy() {
    // Clean up subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.store.dispatch(ResetDrive());
    this.resizeObserver.disconnect();
  }

  subscribeToFileExplorerFiles() {
    return this.store.select(state => state.fileExplorer?.fileList).subscribe((files) => {
      this.activeEntityData = files?.map(file => ({
        ...file,
        icon: {
          name: (file.mimeType === 'application/vnd.google-apps.folder' || file.mimeType === 'folder') ? 'fa-regular fa-folder' : file.mimeType === 'text/plain' ? 'fa-regular fa-file-lines' : file.mimeType === 'audio/x-m4a' ? 'fa-regular fa-compact-disc' : file.mimeType === 'video/mp4' ? 'fa-regular fa-clapperboard' : (file.mimeType === 'application/vnd.google-apps.spreadsheet' || file.mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ? 'fa-regular fa-table-cells-large' : (file.mimeType === 'application/vnd.google-apps.document' || file.mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') ? 'fa-regular fa-line-columns' : file.mimeType === 'application/msonenote' ? 'fa-regular fa-notebook' : file.mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ? 'fa-regular fa-presentation-screen' : 'fa-regular fa-file',
          color: file.mimeType === 'application/vnd.google-apps.folder' ? '' : file.mimeType === 'text/plain' ? 'var(--primary-color)' : file.mimeType === 'folder' ? 'var(--warning-color)' : file.mimeType === 'audio/x-m4a' ? 'var(--markdown-info-blue)' : file.mimeType === 'video/mp4' ? 'var(--markdown-instruction-red)' : (file.mimeType === 'application/vnd.google-apps.spreadsheet' || file.mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ? 'var(--success-hover-color)' : (file.mimeType === 'application/vnd.google-apps.document' || file.mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') ? 'var(--primary-hover-color)' : file.mimeType === 'application/msonenote' ? 'var(--progress-color)' : file.mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ? 'var(--markdown-instruction-red)' : ''
        },
        type: (file.mimeType === 'application/vnd.google-apps.folder' || file.mimeType === 'folder') ? 'folder' : file.mimeType === 'text/plain' ? 'text' : file.mimeType === 'audio/x-m4a' ? 'audio' : file.mimeType === 'video/mp4' ? 'video' : (file.mimeType === 'application/vnd.google-apps.spreadsheet' || file.mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ? 'spreadsheet' : (file.mimeType === 'application/vnd.google-apps.document' || file.mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') ? 'document' : file.mimeType === 'application/msonenote' ? 'note' : file.mimeType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ? 'presentation' : 'file'
      })).sort((a, b) => {
        const isAType = (a.mimeType === 'application/vnd.google-apps.folder' || a.mimeType === 'folder');
        const isBType = (b.mimeType === 'application/vnd.google-apps.folder' || b.mimeType === 'folder');
        if (isAType && !isBType) return -1;
        if (!isAType && isBType) return 1;
        const timeA = new Date(a.lastModifiedDate).getTime();
        const timeB = new Date(b.lastModifiedDate).getTime();
        return timeB - timeA;
      });
    });
  }

  subscribeToFileExplorerLoading() {
    return this.store.select(state => state.fileExplorer?.loading).subscribe((loading) => {
      this.loading = loading;
    });
  }

  subscribeToFileExplorerSubmitButtonLoading() {
    return this.store.select(state => state.fileExplorer?.submitButtonLoading).subscribe((submitButtonLoading) => {
      this.selectedFileListButton.loading = submitButtonLoading;
    });
  }

  subscribeToFileExplorerFolderOrder() {
    return this.store.select(state => state.fileExplorer?.folderOrder).subscribe((folderOrder) => {
      this.folderOrder = folderOrder;
      this.listGridConfig.overflowList.items = folderOrder?.map(folder => folder.name);
      this.calculateUsableGridHeight();
    });
  }

  subscribeToActiveProvider() {
    return this.store.select(state => state.fileExplorer?.activeProvider).subscribe((activeProvider) => {
      if (activeProvider === null) {
        this.router.navigate([FullPaths.AIDataSourcesCreate]);
      }
    });
  }

  subscribeToProjectModels() {
    return this.store.select(<any>getProjectModelsWithFields).subscribe(projectModels => {
      this.selectProjectModels = projectModels?.map(projectModel => ({
        key: projectModel?.title || projectModel?.name,
        value: projectModel?.id
      }));
      if (this.selectProjectModels?.length) {
        const selectProjectModel = this.fileListEditFormConfig?.items.find(item => item.fieldName === 'selectProjectModel');
        selectProjectModel.options = this.selectProjectModels;
      }
    });
  }

  subscribeToCategories() {
    return this.store.select(getCategories).subscribe((categories: Category[]) => {
      this.categories = categories;
      if (this.categories?.length) {
        const selectCategory = this.fileListEditFormConfig?.items.find(item => item.fieldName === 'categoryId');
        selectCategory.options = this.categories?.map(category => ({
          key: category?.title || category?.name,
          value: category.id
        }));
        this.fileListEditFormConfig = { ...this.fileListEditFormConfig };
      }
    });
  }

  onRowActionClick(row: any) {
    if (row.mimeType === 'application/vnd.google-apps.folder' || row.mimeType === 'folder') {
      this.store.dispatch(GetFileExplorerFileList({ payload: { searchText: '', folderId: row?.id, folderName: row?.name } }));
      this.selectedItem = null;
    } else {
      this.selectedItem = row === this.selectedItem ? null : row;
    }
    if (this.selectedList?.length) {
      this.fileListButton.tooltipText = 'Click to ingest';
    } else {
      this.fileListButton.tooltipText = 'Please select an item';
    }
  }

  onFileListButtonClick(selectedList) {
    if (selectedList?.length) {
      this.store.dispatch(IngestMultipleFilesExplorer({
        payload: {
          fileIds: selectedList?.map(item => item.id), isApproved: this.isApproved, categoryId: this.categoryId, fileMetadata: selectedList?.map(s => ({
            fileId: s.id,
            metadata: this.fileMetadata
          }))
        }
      }));
    }
  }

  onSearchTextChange(searchText: string) {
    this.store.dispatch(OrderFileExplorerReset());
    this.store.dispatch(GetFileExplorerFileList({ payload: { searchText } }));
  }

  onOverflowlistItemClick(item) {
    this.selectedItem = null;
    if (item === 'root') {
      this.store.dispatch(OrderFileExplorerReset());
      this.store.dispatch(GetFileExplorerFileList({ payload: { searchText: '' } }));
    }
    const findParent = this.folderOrder?.find(folder => folder.name === item);
    this.store.dispatch(GetFileExplorerFileList({ payload: { searchText: '', folderId: findParent?.id, folderName: findParent?.name } }));
    this.calculateUsableGridHeight();
  }

  calculateUsableGridHeight() {
    // To find the total height of the td elements, the other elements are removed
    this.listGridConfig.pageSize = Math.floor((this.gridHeight - (this.folderOrder?.length ? 350 : 330)) / 36);
    this.listGridConfig = { ...this.listGridConfig };
  }

  onSelectList(selectList) {
    this.selectedList = Array.from(new Map([...new Set([...(this.selectedList ?? []), ...selectList]?.filter(item => item.selected === true))].filter(item => !selectList.some(selectItem => selectItem.id === item.id && selectItem.selected === false)).map(item => [item.id, item])).values());
    if (this.selectedList?.length) {
      this.selectedFileListButton.tooltipText = 'Click to next step';
    } else {
      this.selectedFileListButton.tooltipText = 'Please select an item';
    }
  }

  onSelectedList(selectedList) {
    this.selectedList = selectedList;
    const idSet = new Set(this.selectedList?.map(item => item.id));
    this.activeEntityData.forEach((obj1, i) =>
      Object.keys(this.activeEntityData.map(item => ({
        ...item,
        selected: idSet.has(item.id),
      }))[i]).forEach(key => {
        if (obj1[key] !== this.activeEntityData.map(item => ({
          ...item,
          selected: idSet.has(item.id),
        }))[i][key]) obj1[key] = this.activeEntityData.map(item => ({
          ...item,
          selected: idSet.has(item.id),
        }))[i][key];
      })
    );
  }

  onFormValueChange(formValue) {
    if (this.activeIngestDataStatus !== formValue?.ingestDataTo) {
      if (formValue?.ingestDataTo === 'IngestToAnExistingDataTable') {
        const selectProjectModelVisible = this.fileListEditFormConfig.items?.find(item => item.fieldName === 'selectProjectModel');
        selectProjectModelVisible.visible = true;
        this.fileListEditFormConfig = { ...this.fileListEditFormConfig };
      } else if (formValue?.ingestDataTo === 'ingestToAnewDataTable' || formValue?.ingestDataTo === 'IngestToTheDefaultDataTableOfTheDataSource') {
        const selectProjectModelVisible = this.fileListEditFormConfig.items?.find(item => item.fieldName === 'selectProjectModel');
        selectProjectModelVisible.visible = false;
        this.fileListEditFormConfig = { ...this.fileListEditFormConfig };
      }
    }
    if (formValue?.ingestDataTo === 'ingestToAnewDataTable') {
      this.fileMetadata = { key: 'createNewProjectModel', value: true };
    }
    if (formValue?.ingestDataTo === 'IngestToAnExistingDataTable') {
      this.fileMetadata = { key: 'projectModelId', value: formValue?.selectProjectModel };
    }
    if (formValue?.ingestDataTo === 'IngestToTheDefaultDataTableOfTheDataSource') {
      this.fileMetadata = { key: 'createNewProjectModel', value: false };
    }
    this.isApproved = formValue?.isApproved;
    this.categoryId = formValue?.categoryId;
  }

}
